import { render, staticRenderFns } from "./ResetPwdWindow.vue?vue&type=template&id=35171d28&scoped=true&"
import script from "./ResetPwdWindow.vue?vue&type=script&lang=js&"
export * from "./ResetPwdWindow.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwdWindow.vue?vue&type=style&index=0&id=35171d28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35171d28",
  null
  
)

export default component.exports